
import classes from './Links.module.css'
import twitterLogo from '../assets/twitter.svg'
import ethScanLogo from '../assets/snowtrace.svg'
import openseaLogo from '../assets/joepegs.png'
import discordLogo from '../assets/discord.svg'
function Links(){
return <div>
    
    <div className={classes.container}>

     <a href="https://snowtrace.io/address/0xa996F7F3BC647EebC98C684aB0A302c9b85d2FA1" target="_blank"><img src={ethScanLogo} height='24px' width='24px'></img></a>
    <a href="https://joepegs.com/collections/0xa996f7f3bc647eebc98c684ab0a302c9b85d2fa1" target="_blank"><img src={openseaLogo} height='24px' width='24px'></img></a> 
        <a href='https://twitter.com/MarketingKangru' target="_blank"><img src={twitterLogo} height='24px' width='24px'></img></a>
        <a href='https://discord.gg/QEbMjwcUBh' target="_blank"><img src={discordLogo} height='24px' width='24px'></img></a>

</div>

</div>
}
export default Links